import { useQuery } from '@tanstack/react-query';
import { adminLocalizationApi, adminLocalizationKeys } from '@/api';
import { useEffect, useState } from 'react';
import { sortWithNulls } from '@/utils/helpers';

export const useQuestionnaireSections = (questionnaireId, visibleConditions) => {
  const [dataSorted, setDataSorted] = useState(null);
  const [dataSortedSum, setDataSortedSum] = useState(null);
  const [loading, setLoading] = useState(true);
  const [answers, setAnswers] = useState([]);
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [adminLocalizationKeys.getQuestionnaireSections],
    queryFn: () =>
      adminLocalizationApi.getQuestionnaireSections({ questionSectionTypeId: questionnaireId }),
    select: (res) => res.data
  });

  useEffect(() => {
    if (!data || !data.length || isLoading) return;

    let answrs = [];
    const dataToSort = [...data];

    const sorted = dataToSort
      .map((section) => {
        const filteredGroups = section.questionGroups
          .map((group) => {
            const filteredQuestions = group.questions
              .filter(
                (question) => question.availableAnswers && question.availableAnswers.length > 0
              )
              .map((question) => {
                question.availableAnswers.forEach((answer) => {
                  if (
                    visibleConditions &&
                    Array.isArray(visibleConditions) &&
                    visibleConditions.length
                  ) {
                    const found = visibleConditions.find((cond) => cond.value === answer.id);
                    if (found) {
                      answrs.push(answer);
                    }
                  }
                });

                return {
                  ...question,
                  availableAnswers: [...question.availableAnswers].sort((a, b) =>
                    sortWithNulls(Number(a.sortOrder), Number(b.sortOrder))
                  )
                };
              })
              .sort((a, b) => sortWithNulls(Number(a.sortOrder), Number(b.sortOrder)));

            return { ...group, questions: filteredQuestions };
          })
          .filter((group) => group.questions.length > 0)
          .sort((a, b) => sortWithNulls(Number(a.sortOrder), Number(b.sortOrder)));

        return { ...section, questionGroups: filteredGroups };
      })
      .filter((section) => section.questionGroups.length > 0)
      .sort((a, b) => sortWithNulls(Number(a.newNumber) - Number(b.newNumber)));

    const sortedSum = dataToSort
      .map((section) => {
        const filteredGroups = section.questionGroups
          .map((group) => {
            const filteredQuestions = group.questions
              .filter((question) => question.type === 'FLOAT')
              .sort((a, b) => sortWithNulls(Number(a.sortOrder), Number(b.sortOrder)));

            return { ...group, questions: filteredQuestions };
          })
          .filter((group) => group.questions.length > 0)
          .sort((a, b) => sortWithNulls(Number(a.sortOrder), Number(b.sortOrder)));

        return { ...section, questionGroups: filteredGroups };
      })
      .filter((section) => section.questionGroups.length > 0)
      .sort((a, b) => sortWithNulls(Number(a.newNumber) - Number(b.newNumber)));

    setLoading(false);
    setDataSorted(sorted);
    setDataSortedSum(sortedSum);
    setAnswers(answrs);
  }, [data, isLoading, visibleConditions]);

  return {
    isLoading,
    isError,
    data,
    error,
    dataSorted,
    dataSortedSum,
    loading,
    answers,
    setAnswers
  };
};
